import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: "Block",
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', opacity: 0, display: 'none'})),
      state('expanded', style({ height: 'auto', opacity: 1, display: 'block' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class Block implements OnInit, OnDestroy  {

  @Input("icon") icon: any;
  @Input("h1") h1: any;
  @Input("onHover") onHover: any;
  @Input("h2") h2: any;
  @Input("callToAction") callToAction: any;
  @Input("expandable") expandable: boolean;
  public expanded: boolean = true;

  constructor() {}

  ngOnInit() {
  }

  ngAfterViewInit(){
  }


  ngOnDestroy(){
  }
}
